export const truncateHtml = (text: string, maxLength: number, suffix = '...'): string => {
  if (!text) return ''

  // Check if text contains HTML tags
  const hasHtmlTags = /<[^>]*>/g.test(text)

  if (!hasHtmlTags) {
    // Plain text truncation - use simple character count
    return text.length > maxLength
      ? text.slice(0, maxLength) + suffix
      : text
  }

  // HTML-aware truncation
  let textLength = 0
  let result = ''
  const tagStack: string[] = []
  let i = 0

  while (i < text.length && textLength < maxLength) {
    const char = text[i]

    if (char === '<') {
      // Found start of HTML tag
      const tagEnd = text.indexOf('>', i)
      if (tagEnd === -1) {
        // Malformed HTML, treat as text
        result += char
        textLength++
        i++
        continue
      }

      const tag = text.slice(i, tagEnd + 1)
      result += tag

      // Track opening and closing tags to ensure proper nesting
      const tagMatch = tag.match(/<\/?([a-zA-Z][a-zA-Z0-9]*)/i)
      if (tagMatch) {
        const tagName = tagMatch[1].toLowerCase()

        if (tag.startsWith('</')) {
          // Closing tag - remove from stack
          const stackIndex = tagStack.lastIndexOf(tagName)
          if (stackIndex !== -1) {
            tagStack.splice(stackIndex, 1)
          }
        } else if (!tag.endsWith('/>')) {
          // Opening tag (not self-closing) - add to stack
          // Skip void elements that don't need closing tags
          const voidElements = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']
          if (!voidElements.includes(tagName)) {
            tagStack.push(tagName)
          }
        }
      }

      i = tagEnd + 1
    } else if (char === '&') {
      // Handle HTML entities (like &amp;, &lt;, etc.)
      const entityEnd = text.indexOf(';', i)
      if (entityEnd !== -1 && entityEnd - i < 10) {
        // Found entity, count as 1 character
        result += text.slice(i, entityEnd + 1)
        textLength++
        i = entityEnd + 1
      } else {
        // Not a valid entity, treat as regular character
        result += char
        textLength++
        i++
      }
    } else {
      // Regular character
      result += char
      textLength++
      i++
    }
  }

  // If we truncated, add suffix and close any open tags
  if (textLength >= maxLength && i < text.length) {
    result += suffix

    // Close any remaining open tags in reverse order
    while (tagStack.length > 0) {
      const tagName = tagStack.pop()
      result += `</${tagName}>`
    }
  }

  return result
}
